<div class="card panel-flat-color primary-panel">
    <div class="panel-flat-header">
        <div style="display: inline-block; vertical-align: middle;">
            <h3 class="panel-title">Collector Details</h3>
        </div>
        <div class="float-end header-button-container">
            @if (!(editMode || viewOnly)) {
                <button class="ace-btn btn-text has-icon btn-primary"
                        (click)="edit()">
                    <i class="fa fa-pencil"></i>
                </button>
            }
            @if (editMode) {
                <span class="float-end">
          <button class="ace-btn btn-text has-icon btn-primary btn-success" (click)="save()">
            <i class="fa fa-save"></i>
          </button>
          <button class="ace-btn btn-text has-icon btn-primary btn-danger" (click)="cancel();">
            <i class="fa fa-close"></i>
          </button>
        </span>
            }
        </div>
        <div class="clearfix"></div>
    </div>
    <div class="panel-flat-body">
        @if (collector) {
            <dl class="row">
                <dt class="col-4 text-end">Abbr:</dt>
                <dd class="col-8">
                    @if (!editMode) {
                        <div>
                            {{ collector.abbr }} {{ collector.municipalityName }}
                        </div>
                    }
                    @if (editMode) {
                        <div>
                            <input type="text" class="form-control" [(ngModel)]="editingCollector.abbr" maxlength="100">
                        </div>
                    }
                </dd>
                <dt class="col-4 text-end">Full Name:</dt>
                <dd class="col-8">
                    @if (!editMode) {
                        <div>
                            {{ collector.name }}
                        </div>
                    }
                    @if (editMode) {
                        <div>
                            <input type="text" class="form-control" [(ngModel)]="editingCollector.name" maxlength="65">
                        </div>
                    }
                </dd>
                <dt class="col-4 text-end">Website:</dt>
                <dd class="col-8">
                    @if (!editMode) {
                        <div>
                            <a [href]="collector.website | wsAbsoluteUrl" target="_blank">{{ collector.website }}</a>
                        </div>
                    }
                    @if (editMode) {
                        <div>
                            <input type="text" class="form-control" [(ngModel)]="editingCollector.website">
                        </div>
                    }
                </dd>
                <dt class="col-4 text-end">Annual Rate Increase:</dt>
                <dd class="col-8">
                    @if (!editMode) {
                        <div>
                            {{ collector.annualRateIncrease | percent: '1.0-3' }}
                        </div>
                    }
                    @if (editMode) {
                        <div>
                            <input type="number"
                                   class="form-control"
                                   [(ngModel)]="editingCollector.annualRateIncrease"
                                   [numbersOnly]>
                        </div>
                    }
                </dd>
                <dt class="col-4 text-end">PTX ID:</dt>
                <dd class="col-8">
                    @if (!editMode) {
                        <div>
                            {{ collector.ptxId }}
                        </div>
                    }
                    @if (editMode) {
                        <div>
                            <input type="text" class="form-control" [(ngModel)]="editingCollector.ptxId">
                        </div>
                    }
                </dd>
                <dt class="col-4 text-end">Default Address:</dt>
                <dd class="col-8">
                    <address-view-edit [address]="defaultAddress" [isEditMode]="false"></address-view-edit>
                </dd>
                <dt class="col-4 text-end">Addresses:</dt>
                <dd class="col-8">
                    <a class="ace-btn btn-link pointer p-0" (click)="launchAddressDetailsModal()">
                        Addresses ({{ addressesLength }})
                    </a>
                </dd>
            </dl>
        }
        @if (!editMode) {
            <div class="text-end ws-button-row" style="justify-content: end;">
                <entity-comments [hasComments]="collector.hasComments"
                                 buttonClass="has-icon btn-lg"
                                 [getModalData]="getCommentsModalData">
                </entity-comments>
                <entity-attachments buttonClass="has-icon btn-lg"
                                    [(hasAttachments)]="collector.hasAttachments"
                                    [modalData]="attachmentsModel">
                </entity-attachments>
            </div>
        }
    </div>
</div>
